import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${(props) => props.purple && "#3B045D"};
  position: relative;
  z-index: 4;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeIn {
    animation-name: fadeIn;
  }

  .fadeInDown {
    animation-name: fadeInDown;
  }

  .fadeInUp {
    animation-name: fadeInUp;
  }

  .animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }

  .delayOne {
    animation-delay: 0.3s;
  }

  .delayTwo {
    animation-delay: 0.5s;
  }

  .delayThree {
    animation-delay: 0.6s;
  }

  .delayFour {
    animation-delay: 0.95s;
  }
`;

export const Title = styled.div`
  color: #fff;
  font-size: 2em;
  font-weight: 700;
  margin: 10px 0;
  text-align: center;

  ${mediaMaxWidth.phone`
    font-size: 1.4em;
    margin: 0;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 1.2em;
  `}
`;

export const Text = styled.div`
  color: #c5c5c5;
  font-size: 1.2em;
  font-weight: 400;
  margin: 20px 0;
  max-width: 600px;
  text-align: center;

  ${mediaMaxWidth.phone`
    font-size: 0.92em;
    padding: 0 10px;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.8em;
    padding: 0 5px;
  `}
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  button {
    margin: 20px 10px;
  }
`;

export const AlternativeText = styled.span`
  color: #fff;
  font-size: 1.2em;
  margin: 20px 0;
  color: #c5c5c5;

  ${mediaMaxWidth.phone`
    font-size: 1.1em;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 1em;
  `}
`;
